module.exports = __webpack_public_path__ + "img/routemap.fdd64e02.png";